import {
  checkIncompleteField
} from 'components/form_builder/features/data/dataSlice'
import React, { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { uniqueComponentKey } from '../../utility'
import FilterBar from './FilterBar'
import LabelsList from './LabelsList'
import Searchbar from './Searchbar'

export const TABS = Object.freeze({
  INCOMPLETE: 'incomplete',
  ALL: 'all',
})

const useFilteredComponents = (components) => {
  const [query, setQuery] = useState('')

  const filteredComponents = useMemo(() => {
    if (!query) return components

    const lowerQuery = query.toLowerCase()
    return components.filter((c) => c.label?.toLowerCase().includes(lowerQuery))
  }, [components, query])

  return { filteredComponents, setQuery }
}

const Fields = () => {
  const [activeTab, setActiveTab] = useState(TABS.ALL)
  const allComponents = useSelector(({ components }) => components.all)
  const allData = useSelector(({ data }) => data)

  const components = useMemo(() => {
    return Object.values(allComponents)
      .filter(
        ({ type, subtype }) =>
          type === 'data' || type === 'checkbox' || (type === 'signature' && subtype === 'signature')
      )
      .map((component) => ({
        key: uniqueComponentKey(component.type, component.id, component.subtype),
        keyArray: [component.type, component.id, component.subtype],
        id: component.id,
        label: component?.behaviorInputs?.label,
        type: component.type,
        page: component.page,
        subtype: component.subtype,
      }))
  }, [allComponents])

  const { filteredComponents, setQuery: setQueriedLabel } = useFilteredComponents(components)

  const filteredIncompleteComponents = useMemo(() => {
    return filteredComponents.filter((component) =>
      checkIncompleteField(component.type, allData[component.type]?.[component.id])
    )
  }, [filteredComponents, allData])

  const activeComponents = activeTab === TABS.INCOMPLETE ? filteredIncompleteComponents : filteredComponents

  return (
    <div className="content">
      <Searchbar setQueriedLabel={setQueriedLabel} />
      <FilterBar
        activeTab={activeTab}
        onTabClick={setActiveTab}
        numberIncompleteField={filteredIncompleteComponents.length}
      />
      <LabelsList componentsList={activeComponents} />
    </div>
  )
}

export default Fields
